var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('br'),_c('br'),_c('br'),_c('h2',{staticClass:"txt-center"},[_vm._v("Finalizaste la encuesta de este año.")]),_c('p',{staticClass:"txt-center"},[_vm._v(" ¡Gracias por completar la encuesta! Tu participación es fundamental para el crecimiento y bienestar del ILSB y de quienes lo integramos. ")])])
}]

export { render, staticRenderFns }